// The portal forwards the OQ sigType string ('none' | 'full' | 'initials');
// older portal builds sent a numeric enum where 0 meant none.
export function isSignatureRequired(sigType: unknown): boolean {
  return !(sigType === 0 || String(sigType ?? '').trim().toLowerCase() === 'none');
}
